import { Button } from '@mui/material'
import { Cookie } from '../cookie-banner'
import { saveCookieSettings } from '../utils/save-cookie-settings'

export function AcceptAllButton({ closeModal }: { closeModal: () => void }) {
  const optionalCookies = [Cookie['statistical']]

  return (
    <Button
      variant="contained"
      onClick={() => {
        saveCookieSettings(new Set(optionalCookies))
        closeModal()
      }}
    >
      Accept all
    </Button>
  )
}
